export class ClaimWithSource {

  constructor(public RawDataImport_ShardClaimIdentifier: number,
              public Source: string) {}
}
